import { RecordMeta } from "../../clay/meta";
import { genUUID, UUID } from "../../clay/uuid";
import { Version } from "../version";

//!Data
export type Role = {
    id: UUID;
    recordVersion: Version;

    name: string;
    permissions: string[];
};

// BEGIN MAGIC -- DO NOT EDIT
export type RoleJSON = {
    id: string;
    recordVersion: number | null;
    name: string;
    permissions: string[];
};

export function JSONToRole(json: RoleJSON): Role {
    return {
        id: { uuid: json.id },
        recordVersion: { version: json.recordVersion },
        name: json.name,
        permissions: json.permissions.map((inner) => inner),
    };
}
export type RoleBrokenJSON = {
    id?: string;
    recordVersion?: number | null;
    name?: string;
    permissions?: string[];
};

export function newRole(): Role {
    return JSONToRole(repairRoleJSON(undefined));
}
export function repairRoleJSON(json: RoleBrokenJSON | undefined): RoleJSON {
    if (json) {
        return {
            id: json.id || genUUID(),
            recordVersion:
                json.recordVersion === undefined ? null : json.recordVersion,
            name: json.name || "",
            permissions: (json.permissions || []).map((inner) => inner || ""),
        };
    } else {
        return {
            id: undefined || genUUID(),
            recordVersion: null,
            name: undefined || "",
            permissions: (undefined || []).map((inner) => inner || ""),
        };
    }
}

export function RoleToJSON(value: Role): RoleJSON {
    return {
        id: value.id.uuid,
        recordVersion: value.recordVersion.version,
        name: value.name,
        permissions: value.permissions.map((inner) => inner),
    };
}

export const ROLE_META: RecordMeta<Role, RoleJSON, RoleBrokenJSON> = {
    name: "Role",
    type: "record",
    repair: repairRoleJSON,
    toJSON: RoleToJSON,
    fromJSON: JSONToRole,
    fields: {
        id: { type: "uuid" },
        recordVersion: { type: "version" },
        name: { type: "string" },
        permissions: { type: "array", items: { type: "string" } },
    },
    userFacingKey: "name",
    expressionFunctions: {},
    expressionKeyedFunctions: {},
    expressionKeyedFunctionTypes: {},
};

// END MAGIC -- DO NOT EDIT
